import { render, staticRenderFns } from "./sourceCom.vue?vue&type=template&id=04e78a29&scoped=true"
import script from "./sourceCom.vue?vue&type=script&lang=js"
export * from "./sourceCom.vue?vue&type=script&lang=js"
import style0 from "./sourceCom.vue?vue&type=style&index=0&id=04e78a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e78a29",
  null
  
)

export default component.exports